import Divider from 'components/shared/divider/horizontal'
import Toggler from 'hoc/toggler'
import { WhatsAppIcon } from 'constants/imageMapping'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { getFormValues, reset, touch, initialize } from 'redux-form'
import * as spaceActions from 'actions/spaces/types'
import moment from 'moment'
import Actions from '../include/actions'
import BuildingInquireForms from './building/building-inquire-form'

const formName = 'building-inquire-form'
const BuildingInquiry = ({ infomation, formValues, id, inquireSubmit, dispatch, city }) => {
  const flyspaces_expert = infomation?.building_information?.expert || {}
  const { phone, country, whatsapp_message, image, name, subtitle } = flyspaces_expert
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${whatsapp_message}`

  const resetForm = () => {
    dispatch(reset(formName))
  }

  const setFieldsTouched = () => {
    for (const key in formValues) {
      if (Object.hasOwnProperty.call(formValues, key)) {
        dispatch(touch(formName, key))
      }
    }
  }

  const initialData = useMemo(() => {
    return {
      notes: '',
      firstName: '',
      email: '',
      phone: '',
      expected_number_office_size_or_headcount: '',
      expected_office_size_or_headcount: 'Headcount',
      expected_lease_start_date: '',
      isBuilding: true,
    }
  }, [])

  useEffect(() => {
    dispatch(
      initialize(
        formName,
        {
          ...initialData,
        },
        [
          'notes',
          'firstName',
          'email',
          'phone',
          'expected_number_office_size_or_headcount',
          'expected_office_size_or_headcount',
          'expected_lease_start_date',
          'isBuilding',
        ]
      )
    )
  }, [])
  const handleClick = async (toggle) => {
    setFieldsTouched()
    await new Promise((resolve) => {
      // eslint-disable-next-line radix
      const buildingId = parseInt(id)
      let { expected_lease_start_date: expectedDate } = formValues
      expectedDate = moment(expectedDate).format('yyyy-MM-DD')
      inquireSubmit({
        values: { ...formValues, expected_lease_start_date: expectedDate, building_id: buildingId },
        options: 'building',
        resolve,
        formName,
        resetForm,
      })
    })

    toggle()
  }

  return (
    <div className="inquire inquire-building-form sticky-header-75 w-full bottom-0 right-0 left-0  lg:bg-transparent z-20 mx-auto lg:sticky lg:pl-15px">
      <div className="lg:rounded-lg bg-greytable py-6 mx-auto max-w-lg">
        <div className="flex flex-col w-full mx-auto">
          <div className="flex flex-col items-center justify-around px-4 lg:px-6 xl:px-8 ">
            <div className="building-inquiry-avt-container">
              <img src={image} alt="" />
            </div>
            {<p className="text-black text-xl lato-reg">{name}</p>}
            {/* for testing ui */}
            {'infomation.building_information?.position' && country !== 'Singapore' ? (
              <p className="text-secondary-greypricetype lato-reg text-center">
                {country}&lsquo;s Commercial Real Estate Expert
              </p>
            ) : (
              <p className="text-secondary-greypricetype lato-reg text-center text-sm">
                FLYSPACES ASIA PTE. LTD. <br></br>
              </p>
            )}
            <p className="text-secondary-greypricetype lato-reg text-center text-xs">{subtitle}</p>
            <p className="bg-white border rounded-md flex contactInfoItem">
              <img className="mr-2" src={WhatsAppIcon} alt="whatsapp icon" />
              <a href={whatsappUrl} target={'_blank'} rel={'noreferrer'}>
                Whatsapp
              </a>
            </p>
          </div>
          <div className="px-5 pt-4">
            <Divider className="mb-5 hidden lg:block" />
            <div className="lg:flex-grow flex text-center justify-center">
              <BuildingInquireForms
                className="w-full"
                submitButtonTitle="Send request"
                form={formName}
                city={city}
                handleClick={handleClick}
                initialValues={{
                  ...initialData,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Actions id={8} />
    </div>
  )
}

BuildingInquiry.propTypes = {
  infomation: PropTypes.object,
  id: PropTypes.string,
  formValues: PropTypes.object,
  dispatch: PropTypes.func,
  inquireSubmit: PropTypes.func,
  city: PropTypes.string,
}

const mapStateToProps = ({ building, ...state }) => {
  const formValues = getFormValues(formName)(state) || {}

  return {
    infomation: building.public.details || {}, // checks if the user is currently on the building page via checking the reducer,
    formValues,
    id: building.public.details.id,
  }
}
const mapDispatchToProps = (dispatch) => ({
  inquireSubmit: (payload) =>
    new Promise((resolve, reject) => {
      dispatch({ type: spaceActions.INQUIRE_SUBMIT, payload, resolve, reject })
    }),
  dispatch,
})

export default Toggler(connect(mapStateToProps, mapDispatchToProps)(BuildingInquiry), {
  canceledOnTouchOutside: false,
})
